import { render, staticRenderFns } from "./pardakht-shakhsi.vue?vue&type=template&id=b36dae4a&scoped=true&"
import script from "./pardakht-shakhsi.vue?vue&type=script&lang=js&"
export * from "./pardakht-shakhsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36dae4a",
  null
  
)

export default component.exports